import { error } from "loglevel";
import { Observable, of, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { AppModule } from "src/app/app.module";
import { MemberStorageService } from "src/app/services/member-storage.service";

import { sntLog } from "src/app/common/logger";

const logger = sntLog("CacheIfFailsDecorator");
export function CacheIfFail(cacheKey: string): Function {
  return function (
    target: object,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<(...args: any[]) => Observable<any>>
  ): TypedPropertyDescriptor<(...args: any[]) => Observable<any>> {
    if (!descriptor || typeof descriptor.value !== "function") {
      throw new TypeError(
        `Only methods can be decorated with @CacheIfFail. <${propertyKey}> is not a method!`
      );
    }

    const originalValue: (...args: any[]) => Observable<any> = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const originalObs: Observable<any> | Promise<any> = originalValue.apply(
        this,
        args
      );

      const piped = originalObs.pipe(
        tap((data: any) =>
          AppModule.Injector.get(MemberStorageService).setItem(
            cacheKey,
            JSON.stringify(data)
          )
        ),
        catchError((erorr: any) => {
          const jsonCachedData =
            AppModule.Injector.get(MemberStorageService).getItem(cacheKey);
          if (!jsonCachedData) {
            logger.warn(`[CacheIfFail] ${cacheKey} not found!`);
            return throwError(error);
          }

          return of(JSON.parse(jsonCachedData));
        })
      );

      return piped;
    };

    return descriptor;
  };
}
